import React from 'react'
import styles from './styles.module.scss'
import { useAppIntl } from 'src/i18n'

export const Header = () => {
  const intl = useAppIntl()
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.contentContainer}>
          <h1 className={styles.title}>{intl.t('glossary.header.title')}</h1>
          <h2 className={styles.subtitle}>
            {intl.t('glossary.header.subTilte')}
          </h2>
        </div>
      </div>
    </div>
  )
}
